(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1146],{

/***/ 85459:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/product-terms",
      function () {
        return __webpack_require__(85187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Apps_ProductTerms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js + 1 modules
var GuidePageTemplate = __webpack_require__(41635);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Main.js
var Main = __webpack_require__(43360);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 2 modules
var PostElement = __webpack_require__(77626);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(76136);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/Apps/ProductTerms/index.js















const ProductTerms = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("product-terms");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        locale: t("META.LOCALE"),
                        type: t("META.TYPE"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        url: t("META.URL"),
                        siteName: t("META.SITE_NAME"),
                        articlePublisher: t("META.ARTICLE_PUBLISHER")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: t("META.CANONICAL")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META.TWITTER_CARD"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        site: t("META.TWITTER_SITE"),
                        creator: t("META.TWITTER_CREATOR")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                color: "black--02",
                spacing: {
                    pt: 20
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: t("HERO_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        children: t("HERO_DESCRIPTION")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidePageTemplate/* default */.Z, {
                sidebar: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                    sidebar: false,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementUl */.Nj, {
                            spacing: {
                                my: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    spacing: {
                                        mb: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("OVERVIEW_LIST_ITEM_1", {
                                            url: "#general_terms"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    spacing: {
                                        mb: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("OVERVIEW_LIST_ITEM_2", {
                                            url: "#attachment_1"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    spacing: {
                                        mb: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("OVERVIEW_LIST_ITEM_3", {
                                            url: "#attachment_2"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("MAIN_DESCRIPTION_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH2 */.LA, {
                            id: "general_terms",
                            children: t("SECTION_TITLE_1")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            spacing: {
                                mt: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_TITLE_1_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_1")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_2")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_3")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_4")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_5")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_6")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_7")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_8")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_9")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_10")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_11")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_12", {
                                    howToBuy: routes/* default.external.howToBuy */.Z.external.howToBuy
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_13")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_14")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_15")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_16")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_17")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_18")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_19")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_20")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_21")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_22")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_23")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_24")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_25")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_1_26")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_27")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_28")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_29")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_30")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_1_31")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_TITLE_2")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_2")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_3")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_4")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_5")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_6")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_7")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_8")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_9")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_10")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_11")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_12")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_13")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_DESCRIPTION_2_14", {
                                    goSupport: routes/* default.external.goSupport */.Z.external.goSupport
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: t("SECTION_DESCRIPTION_2_15")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH2 */.LA, {
                            id: "attachment_1",
                            children: t("SECTION_TITLE_3")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementOl */.vb, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_1_1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_1_2")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_1_3")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_1_4")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_2")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_2_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementOl */.vb, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_2_1_1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_2_1_2")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_2_1_3")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_2_1_4")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_3")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_4")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementOl */.vb, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_2")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_3")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_4")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_5")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_6")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_3_LIST_4_7")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_5")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_6")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_7")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_3_LIST_8")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementTitleH2 */.LA, {
                            id: "attachment_2",
                            children: t("SECTION_TITLE_4")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                            spacing: {
                                pl: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_1_1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_1_2")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_1_3")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_1_4")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_2")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementOl */.vb, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_2_1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_2_2")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_2_3")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_2_4")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_3")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_4")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementOl */.vb, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_4_1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                        Tag: "span",
                                        children: t("SECTION_4_LIST_4_2")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_5")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_6", {
                                    privacyPolicy: routes/* default.external.privacyPolicy */.Z.external.privacyPolicy
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            spacing: {
                                pl: 4
                            },
                            children: t("SECTION_4_LIST_6_1")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                Tag: "span",
                                children: t("SECTION_4_LIST_7")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Apps_ProductTerms = (ProductTerms);

;// CONCATENATED MODULE: ./pages/company/product-terms.js



/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24155);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    size: "s",
                    href: "/demos/",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ }),

/***/ 43360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateMain = (param)=>{
    let { sidebar =true , children , ...props } = param;
    const responsiveProps = sidebar ? {
        auto: true
    } : {
        lg: 9
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        ...responsiveProps,
        ...props,
        children: children
    });
};
GuidePageTemplateMain.propTypes = {
    sidebar: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateMain);


/***/ }),

/***/ 41635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GuidePageTemplate_GuidePageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/GuidePageTemplate.js






const GuidePageTemplate = (param)=>{
    let { type ="guide" , wrapperClassName ="" , sidebar =true , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("guide-page-template", "guide-page-template-type-".concat(type), wrapperClassName),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                center: !sidebar,
                children: children
            })
        })
    });
};
GuidePageTemplate.propTypes = {
    type: (0,prop_types.oneOf)([
        "guide",
        "tutorial"
    ]),
    wrapperClassName: prop_types.string,
    sidebar: prop_types.bool,
    children: prop_types.node.isRequired
};
/* harmony default export */ var GuidePageTemplate_GuidePageTemplate = (GuidePageTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js



/***/ }),

/***/ 50410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroDescription = (param)=>{
    let { align , color ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__description", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroDescription.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .textAlignPropTypes */ .g4,
    color: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroDescription);


/***/ }),

/***/ 91319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroTitle = (param)=>{
    let { align , color , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroTitle.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_4__/* .textAlignPropTypes */ .g4,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroTitle);


/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5568,8135,6136,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(85459); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);